/**
 * @author 冷 (https://github.com/LengYXin)
 * @email lengyingxin8966@gmail.com
 * @create date 2021-10-15 17:35:33
 * @modify date 2021-10-15 17:35:33
 * @desc [解析Query]
 */
import lodash from 'lodash';
import queryString from 'query-string';
import { history } from 'umi';
import Store from '../store';
/**
 * 解析分享码
 * @export
 * @param {Context} context
 * @return {*}
 */
export async function ParseToken() {
  const location = history.location;
  const query = lodash.cloneDeep(location.query);
  const pageUrl = queryString.stringifyUrl({
    url: location.pathname,
    query: lodash.omit(query, ['token', 'signedUrl']),
  });
  // 解析分享参数
  await Store.Share.onParseShare(query);
  // 设置推广记录
  await Store.Share.setRecord(query, pageUrl);
  // 解析地址栏携带的登陆信息
  Store.System.onParseQueryToken(query);
}
